module.exports = __webpack_public_path__ + "static/media/delhiwebp.f129fb1e.webp";